import axios from "axios";
import Auth from "../Repository/auth";
import { url } from "./BaseUrl";
const APIBaseUrl = url + "/erp/v1";

Auth();

//Image Upload
export const ImageUpload = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/upload/single_file_upload`, Payload, {
      headers: {
        Accept: "image/json",
        "Content-Type": "image/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Holiday Bulk Upload
export const CreateHolidayBulkUpload = async (formData, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/system_admin/holidays/bulk_upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Employee Bulk Upload
export const CreateEmployeeBulkUpload = async (formData, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/system_admin/employee/bulk_upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//User Login
export const UserLoginSubmit = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/account/login`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Change New Password
export const ChangeNewPassword = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/account/change_password`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Verify Otp
export const VerifyOTPSend = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/login/otp_send`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Sumbit Otp for Forget Password
export const SubmitOtp = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/login/otp_verify`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Sumbit New Password
export const SubmitPassword = async (Payload) => {
  const response = await axios
    .put(`${APIBaseUrl}/login/forgot_password/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Generic function for fetching user profiles
const fetchUserProfile = async (userType, token) => {
  const endpoint = `${APIBaseUrl}/${userType}/my_profile/find_particular`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching ${userType} profile:`, error);
    return { error: error };
  }
};

export const EmployeeProfile = async (token) => {
  return fetchUserProfile("employee", token);
};

export const HodProfile = async (token) => {
  return fetchUserProfile("hod", token);
};

export const AdminProfile = async (token) => {
  return fetchUserProfile("admin", token);
};

export const DirectorProfile = async (token) => {
  return fetchUserProfile("director", token);
};

export const SystemAdminProfile = async (token) => {
  return fetchUserProfile("system_admin", token);
};

export const IndentProfile = async (token) => {
  return fetchUserProfile("indent", token);
};

export const StoreInchargeProfile = async (token) => {
  return fetchUserProfile("store_incharge", token);
};

//Notification
export const ManageNotification = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/notification/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Notification
export const UpdateNotification = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/notification/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Employee Dashboard Count
export const EmployeeDashboardCount = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/dashboard/leave_count`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Dashboard Count
export const DirectorDashboardCount = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/dashboard/count`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Employee Dashboard Leave List
export const DirectorDashboardLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/dashboard/leave_listing?filter_by=today`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Update Profile
const updateProfile = async (userType, Payload, token) => {
  const endpoint = `${APIBaseUrl}/${userType}/my_profile/update`;

  try {
    const response = await axios.put(endpoint, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(`Error updating ${userType} profile:`, error);
    return { error: error };
  }
};

export const UpdateEmployeeProfile = async (Payload, token) => {
  return updateProfile("employee", Payload, token);
};

export const UpdateHodProfile = async (Payload, token) => {
  return updateProfile("hod", Payload, token);
};

export const UpdateAdminProfile = async (Payload, token) => {
  return updateProfile("admin", Payload, token);
};

export const UpdateDirectorProfile = async (Payload, token) => {
  return updateProfile("director", Payload, token);
};

export const UpdateSystemAdminProfile = async (Payload, token) => {
  return updateProfile("system_admin", Payload, token);
};

export const UpdateIndentProfile = async (Payload, token) => {
  return updateProfile("indent", Payload, token);
};

export const UpdateStoreInchargeProfile = async (Payload, token) => {
  return updateProfile("store_incharge", Payload, token);
};

// Get All Leave Type
export const GetLeaveType = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/leave/kinds_of_leave`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get All Alternate Person
export const GetAlternatePerson = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/alternate_staff/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get Gender List
export const GetGenderList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/employee/master_data/find?master_type=childrens_gender`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Child
export const CreateChildren = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/children/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get Children Name
export const GetChildrenName = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/children/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get All Comp Off Worked Date
export const GetCompoffWorkedDate = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/comp_off/find_active`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Leave Application
export const CreateLeaveApplication = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/leave/apply`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Leave List
export const GetLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/leave/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Specific Leave Details
export const SpecificLeave = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/leave/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Rejoin Leave List
export const GetRejoinLeaveList = async (status, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/joining_letter/find?status=${status}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Rejoining Leave Status
export const CreateLeaveRejoining = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/leave/joining_report/submit`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Cancel Leave Status
export const CreateLeaveCancel = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/leave/cancel`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Comp Off Leave List
export const GetEmployeeCompOffLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/comp_off/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Comp Off Leave
export const CreateCompOffLeave = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/comp_off/claim`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Hod Leave List
export const GetHodLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/leave/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetLeaveRejoinList = async (token, status) => {
  const response = await axios
    .get(`${APIBaseUrl}/joining_letter/find?status=${status}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Hod Specific Leave Details
export const HodSpecificLeave = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/leave/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Hod Leave Status
export const UpdateHodLeaveStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/hod/leave/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Hod Comp Off Leave Status
export const UpdateHodCompOffLeaveStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/hod/comp_off/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Comp Off Leave List
export const GetCompOffLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/comp_off/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Comp Off Specific Leave Details
export const CompOffSpecificLeave = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/comp_off/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Admin Leave List
export const GetAdminLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/leave/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Admin Specific Leave Details
export const AdminSpecificLeave = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/leave/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Admin Leave Status
export const UpdateAdminLeaveStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/admin/leave/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Admin Comp Off Leave Status
export const UpdateAdminCompOffLeaveStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/admin/comp_off/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Director Leave List
export const GetDirectorLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/leave/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Director Specific Leave Details
export const DirectorSpecificLeave = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/leave/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Director Leave Status
export const UpdateDirectorLeaveStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/director/leave/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Director Comp Off Leave Status
export const UpdateDirectorCompOffLeaveStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/director/comp_off/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All System Admin Leave List
export const GetSystemadminLeaveList = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/leave/find?employee_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//System Admin Specific Leave Details
export const SystemAdminSpecificLeave = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/leave/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Hod Employee List

export const HodEmployeeActiveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/employee/find?status=active&officer_type=faculty`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetHodEmployeeList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/employee/find?status=active`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Hod Indent Employee List
export const HodIndentEmployeeActiveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/indent/find?status=active`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Hod Specific Employee Details
export const HodSpecificEmployeeView = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/hod/all_user/profile/find_particular?employee_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Admin Employee List
export const AdminEmployeeActiveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/employee/find?status=active&user_type=employee&officer_type=faculty`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetAdminEmployeeActiveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/employee/find?status=active&user_type=employee`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Admin Hod Employee List
export const AdminHodEmployeeActiveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/employee/find?status=active&user_type=hod`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Admin Specific Employee Details
export const AdminSpecificEmployeeView = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/admin/all_user/profile/find_particular?employee_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Employee List
export const DirectorEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/director/employee/find?status=active&user_type=employee`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Hod Employee List
export const DirectorHodEmployeeActiveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/employee/find?status=active&user_type=hod`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Admin Employee List
export const DirectorAdminEmployeeActiveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/employee/find?status=active&user_type=admin`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Indent Employee List
export const DirectorIndentEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/director/employee/find?status=active&user_type=indent`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Store Incharge Employee List
export const DirectorStoreInchargeEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/director/employee/find?status=active&user_type=store_incharge`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Director Specific Employee Details
export const DirectorSpecificEmployeeView = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/director/all_user/profile/find_particular?employee_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// System Admin Employee List
export const SystemAdminEmployeeList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/employee/find?user_type=employee`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// System Admin Hod Employee List
export const SystemadminHodEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/employee/find?status=active&user_type=hod`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// System Admin Admin Employee List
export const SystemadminAdminEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/employee/find?status=active&user_type=admin`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// System Admin Director Employee List
export const SystemadminDirectorEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/employee/find?status=active&user_type=director`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// System Admin Indender Employee List
export const SystemadminIndenderEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/employee/find?status=active&user_type=indent`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// System Admin Store Incharge Employee List
export const SystemadminStoreInchargeEmployeeActiveList = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/employee/find?status=active&user_type=store_incharge`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//System Admin Specific Employee Details
export const SystemadminSpecificEmployeeView = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/all_user/profile/find_particular?employee_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Department List
export const GetDepartmentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/department/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Department Master
export const CreateDepartmentMaster = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/system_admin/department/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Department Master
export const UpdateDepartmentMaster = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/department/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Desigination List
export const GetDesignationList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/desigination/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Designation Master
export const CreateDesignationMaster = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/system_admin/desigination/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Designation Master
export const UpdateDesignationMaster = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/desigination/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Holiday List
export const GetHolidayList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/holidays/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Holiday Master
export const CreateHolidayMaster = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/system_admin/holidays/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Holiday Master
export const UpdateHolidayMaster = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/holidays/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Leave List
export const GetAllLeaveList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/leave_type/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Leave Master
export const UpdateLeaveMaster = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/leave_type/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Message List
export const GetMsessageList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/response_message/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Message Master
export const CreateMessageMaster = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/system_admin/response_message/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Message Master
export const UpdateMessageMaster = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/response_message/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get All User Type
export const GetUserType = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/master_data/find?master_type=user_type`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get All Gender Type
export const GetGenderType = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/system_admin/master_data/find?master_type=gender`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get All Child Gender Type
export const GetChildGenderType = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/master_data/find?master_type=childrens_gender`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Employee
export const CreateEmployee = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/system_admin/account/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Employee
export const UpdateEmployee = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/account/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All System Admin Child List
export const GetSystemadminChildList = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/employee_children/find?employee_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//System Admin Specific Child Details
export const SystemAdminSpecificChild = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/employee_children/find_particular?id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update System Admin child
export const UpdateSystemAdminChild = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/employee_children/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const EmployeePerformanceReportUpdate = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/employee/perfomance_report/fixed_score/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Leave Restriction List
export const GetLeaveRestictionList = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/leave_type/restriction/find?leave_type_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Leave Restriction
export const CreateLeaveRestriction = async (Payload, token) => {
  const response = await axios
    .post(
      `${APIBaseUrl}/system_admin/leave_type/restrictions/create`,
      Payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Leave Restriction
export const UpdateLeaveRestriction = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/system_admin/leave_type/restriction/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Leave Transfer
export const GetLeaveTransfer = async (token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/system_admin/leave_type/restrictions/next_year/create`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//System Admin Reset Password
export const SystemadminResetPassword = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/login/password/reset`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Temporary Report List
export const GetTempReportList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/temporary/activity_report/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Specific Temporary Report Details
export const SpecificTemporaryReport = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/employee/temporary/activity_report/find_particular?id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Staff Activity Temporary
export const CreateStaffReportTemporary = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/temporary/activity_report/save`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Saved Report List
export const GetSavedReportList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/activity_report/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Specific Saved Report Details
export const SpecificSavedReport = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/activity_report/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Staff Activity Permanent
export const CreateStaffReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/activity_report/submit`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Get Director Report
export const GetDirectorReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/director/faculty/activity_report/find`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetHodReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/hod/faculty/activity_report/find`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetAdminReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/admin/faculty/activity_report/find`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Get Director Overall Report
export const GetDirectorOverallReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/director/faculty/activity_report/generate`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Get Hod Overall Report
export const GetHodOverallReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/hod/activity_report/generate`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAdminOverallReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/admin/activity_report/generate`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Director Specific Saved Report Details
export const DirectorSpecificSavedReport = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/director/faculty/activity_report/find_particular?id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
//Hod Specific Saved Report Details
export const HodSpecificSavedReport = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/hod/faculty/activity_report/find_particular?id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const AdminSpecificSavedReport = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/admin/faculty/activity_report/find_particular?id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
// Director Fetching Keys List
export const DirectorFetchingKeysList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/faculty/activity_report/keys`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Director Report Edit Access
export const DirectorReportEditAccess = async (Payload, token) => {
  const response = await axios
    .put(
      `${APIBaseUrl}/director/faculty/activity_report/edit_option_update`,
      Payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const DirectorPerformanceReportEditAccess = async (Payload, token) => {
  const response = await axios
    .put(
      `${APIBaseUrl}/director/perfomance_report/fixed_score/update`,
      Payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Product List
export const GetProductList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/store_incharge/product/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Product Master
export const CreateProductMaster = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/store_incharge/product/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Product Master
export const UpdateProductMaster = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/store_incharge/product/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Product Quantity
export const CreateProductQuantity = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/store_incharge/product/purchase`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Low Product Quantity List
export const GetProductLowQuantityList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/store_incharge/product/below_minimum_quantity`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Store Incharge Specific Product Details
export const StoreInchargeSpecificProductList = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/store_incharge/product/purchase/find?product_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Indent Department List
export const IndentDepartmentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/indent/department/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Indent Item List
export const IndentItemList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/indent/product/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Indent Form
export const CreateIndentForm = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/indent/product/purchase`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Indent Form List
export const GetIndentFormList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/indent/product_purchase/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Specific Indent Details
export const SpecificIndentList = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/indent/product_purchase/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All HOD Indent List
export const GetHodIndentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/product_purchase/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Hod Specific Indent Details
export const HodSpecificIndentList = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/product_purchase/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Hod Indent Status
export const UpdateHodIndentStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/hod/product_purchase/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Director Indent List
export const GetDirectorIndentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/product_purchase/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Director Specific Indent Details
export const DirectorSpecificIndentList = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/product_purchase/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Director Indent request Status
export const DirectorIndentRequestStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/director/product_purchase/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Indentor request Status Update
export const IndentRequestStatusUpdate = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/indent/product_purchase/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Store Incharge Indent List
export const GetStoreIncgargeIndentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/store_incharge/product_purchase/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Store Incharge Specific Indent Details
export const StoreInchargeSpecificIndentList = async (id, token) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/store_incharge/product_purchase/find_particular?id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Store Incharge request Status Update
export const StoreInchargeRequestStatusUpdate = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/store_incharge/product_purchase/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Get Staff Overall Report
export const GetStaffOverallReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/activity_report/generate`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Store Incharge Indent Filter
export const StoreInchargeIndentFilter = async (
  department_id,
  start_date,
  end_date,
  token
) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/store_incharge/product_purchase/find?department_id=${department_id}&start_date=${start_date}&end_date=${end_date}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Department List Store Incharge
export const GetStoreinchargeDepartmentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/store_incharge/department/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// All Department List Director
export const GetDirectorDepartmentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/department/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Indent Filter
export const DirectorIndentFilter = async (
  department_id,
  start_date,
  end_date,
  token
) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/director/product_purchase/find?department_id=${department_id}&start_date=${start_date}&end_date=${end_date}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Performance static count List
export const GetPerformanceCountList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/perfomance_matrix/fixed_score`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create Performance Report
export const CreatePerfomanceReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/perfomance_report/submit`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Saved Performance Report List
export const GetSavedPerformanceReportList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/perfomance_report/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetPerformanceScoreFixedList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/perfomance_report/fixed_score/find_all?status=pending_editable`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetPerformanceScoreFixedListSubmitted = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/perfomance_report/fixed_score/find_all?status=submitted`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const HodPerformanceListAll = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/perfomance_report/fixed_score/find_all`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetPropertyReturnsList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/property_returns/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetAdminPropertyReturnsList = async (year, id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/property_returns/find?academic_year=${year}&employee_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Specific Saved Performnance Report Details
export const SpecificPerformanceSavedReport = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/perfomance_report/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Specific Saved Performnance Report Details
export const StaffSpecificPerformanceSavedReport = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/perfomance_report/fixed_score/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const SpecificPerformanceReport = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/perfomance_report/fixed_score/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Performance Report List
export const GetDirectorPerformanceReportList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/perfomance_report/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Director Performance Report Filter
export const DirectorPerformanceReportFilter = async (
  employee_id,
  academic_year,
  month,
  token
) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/director/perfomance_report/find?employee_id=${employee_id}&academic_year=${academic_year}&month=${month}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Director Specific Saved Performnance Report Details
export const DirectorSpecificPerformanceSavedReport = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/perfomance_report/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Get Employee Overall Performance Report
export const GetEmployeeOverallPerformanceReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/perfomance_report/report_generate`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Get Director Overall Performance Report
export const GetDirectorOverallPerformanceReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/director/perfomance_report/report_generate`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get Director Report Employee
export const GetDirectorReportEmployee = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/director/faculty/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Hod Indent Reset Password
export const HodIndentResetPassword = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/login/password/reset`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};


export const HodAddComments = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/hod/faculty/activity_report/add_comments`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const HodGetPendingComments = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/hod/faculty/activity_report/find_pending_comments`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const UploadPropertyReturnsDocument = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employee/property_returns/submit`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get Director Report Employee
export const GetPropertyReport = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/property_returns/base_file/download`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const HodAparReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/hod/apar/submit`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const findAllAparReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/apar/find_all`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const findAparSpecificView = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/apar/find_particular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const DirectorAparReport = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/director/apar/submit`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const LeaveTypeList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/report/leave_type`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const AdminEmployeeLeaveInfo = async (id, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/leave/balance?employee_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetadminDepartmentList = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/department/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const AdminDepartmentUpdate = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/admin/employee/profile/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const RejoinApproval = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/joining_letter/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetEmployeeHistoryCount = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/leave_history/count_listing?employee_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetEmployeeBalanceCount = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/leave_balance/count_listing?employee_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateEmployeeHistoryCount = async (token, payload) => {
  const response = await axios
    .put(`${APIBaseUrl}/employee/leave_history/count_update`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateEmployeeBalanceCount = async (token, payload) => {
  const response = await axios
    .put(`${APIBaseUrl}/employee/leave_balance/count_update`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};